module.exports = __webpack_public_path__ + "img/lb3.1c93d4aa.jpg";